import moment from "moment";
import yup from "src/validators/yup.Module";

export interface ProdutoConsultaDto {
  nome: string;
}

export interface ProdutoConsultaComandoDto {
  valor?: number;
  quantidade?: number;
  codigoProduto: string;
}

export interface NFCeDto {
  id?: number;
  serie: string;
  numeroNF: number;
  destinatario?: DestinatarioNFCeDto;
  itens?: ProdutoNFCeDto[];
  pagamento?: MeioPagamentoNFCeDto[];
  total?: NFCeTotalDto;
  autorizacao?: NFCeAutorizacaoDto;
  emissaoDataHora?: string | moment.Moment | null;
}

export interface NFCeTotalDto {
  id: number;
  valorBC: number;
  valorICMS: number;
  valorICMSDeson: number;
  valorFCPUFDest: number;
  valorICMSUFDest: number;
  valorICMSUFReme: number;
  valorFCP: number;
  valorBCST: number;
  valorST: number;
  valorFCPST: number;
  valorFCPSTRet: number;
  valorProduto: number;
  valorFrete: number;
  valorSeguro: number;
  valorDesconto: number;
  valorII: number;
  valorIPI: number;
  valorIPIDevol: number;
  valorPis: number;
  valorCofins: number;
  valorOutro: number;
  valorNotaFiscal: number;
  valorAproxTributos: number;
  valorTroco: number;
}

export interface NFCeAutorizacaoDto {
  id: number;
  chaveAcesso: string;
  urlChave: string;
  urlQrCode: string;
  codigoStatusEnvio: number;
  descricaoStatusEnvio: string;
  codigoStatusResposta: number;
  numeroProtocolo: string | null;
  descricaoMotivoResposta: string;
  recebimentoDataHora: string | moment.Moment | null;
}

export const statusEnvioOptions = [
  { value: "0", label: "Aguardando Envio" },
  { value: "1", label: "Enviada Sem Retorno" },
  { value: "2", label: "Finalizada" },
  { value: "3", label: "Finalizada Denegada" },
  { value: "99", label: "Todos" },
];

export interface NFCeConsultaInputDto {
  codigoStatusEnvio?: string | null;
  dataEmissaoInicial?: Date | null;
  dataEmissaoFinal?: Date | null;
  serie?: number | null;
  id?: number | null;
}

export interface DestinatarioNFCeDto {
  documento: string;
  nome: string;
  indicadorInscricaoEstadual: number;
}

export interface ProdutoNFCeDto {
  index: number;
  id: number;
  categoriaId: number;
  codigoProduto: string;
  codigoBarras: string;
  nome: string;
  descricao: string;
  codigoNCM: string;
  cfop: string;
  sequencia: number;
  unidadeComercial: string;
  quantidadeComercial: number;
  valorUnitarioComercial: number;
  valorTotal: number;
  codigoBarrasTributavel: string;
  unidadeTributavel: string;
  quantidadeTributavel: number;
  valorUnitarioTributavel: number;
  valorFrete: number;
  valorSeguro: number;
  valorDesconto: number;
  outrasOutro: number;
  indicaTotal: number;
  categoriaNome: string;
  icms?: ICMSNFCeDto;
}

export interface ICMSNFCeDto {
  id: number;
  totalTributos: number;
  origem: number;
  cst: number;
  aliquotaCreditoSimples: number;
  valorCreditoSimples: number;
  modalidadeBC: number;
  valorBC: number;
  percentualRedBC: number;
  percentualICMS: number;
  valorICMS: number;
  modalidadeBCST: number;
  percentualMVAST: number;
  percentualRedBCST: number;
  valorBCST: number;
  percentualICMSST: number;
  valorICMSST: number;
  valorBCSTRetido: number;
  percentualST: number;
  valorICMSSubstituto: number;
  valorICMSSTRetido: number;
  origemDescricao?: string | null;
}

export interface MeioPagamentoNFCeDto {
  id: number;
  meioPagamento: number | undefined;
  valorPagamento: number;
  tipoIntegracao: number | null;
}

export interface MeioPagamentoDto {
  meioPagamento: number;
  descricaoPagamento: string;
}

export const meioPagamento: MeioPagamentoDto[] = [
  { meioPagamento: 1, descricaoPagamento: "Dinheiro" },
  { meioPagamento: 2, descricaoPagamento: "Cheque" },
  { meioPagamento: 3, descricaoPagamento: "Cartão Crédito" },
  { meioPagamento: 4, descricaoPagamento: "Cartão Débito" },
  { meioPagamento: 5, descricaoPagamento: "Crédito Loja" },
  { meioPagamento: 10, descricaoPagamento: "Vale Alimentação" },
  { meioPagamento: 11, descricaoPagamento: "Vale Refeição" },
  { meioPagamento: 12, descricaoPagamento: "Vale Presente" },
  { meioPagamento: 13, descricaoPagamento: "Vale Combustível" },
  { meioPagamento: 15, descricaoPagamento: "Boleto Bancário" },
  { meioPagamento: 16, descricaoPagamento: "Depósito Bancário" },
  { meioPagamento: 17, descricaoPagamento: "Pagamento Instantâneo (PIX)" },
  { meioPagamento: 18, descricaoPagamento: "Transferência Bancária" },
  { meioPagamento: 19, descricaoPagamento: "Programa Fidelidade/Cashback" },
  { meioPagamento: 90, descricaoPagamento: "Sem Pagamento" },
  { meioPagamento: 99, descricaoPagamento: "Outros" },
];

export const ProdutoConsultaSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
